var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.076,
    height: 13.297,
    viewBox: "0 0 20.076 13.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2046",
    "data-name": "Group 2046",
    transform: "translate(12.045 -269.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3430",
    "data-name": "Path 3430",
    d: "M-1.7,282.91c-4.446-.115-7.848-2.222-10.286-6.488a.325.325,0,0,1,.005-.374c1.859-3.306,4.409-5.456,7.692-6.163,4.492-.967,8.294.652,11.338,4.723.342.457.619.983.931,1.473a.264.264,0,0,1,0,.314,11.892,11.892,0,0,1-7.848,6.243C-.513,282.784-1.176,282.834-1.7,282.91Zm-8.652-6.678c4.328,6.808,12.765,6.4,16.68-.012C2.114,269.6-6.188,269.658-10.353,276.231Z",
    transform: "translate(0 0)",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3431",
    "data-name": "Path 3431",
    d: "M173.382,345.753a3.338,3.338,0,1,1,3.332-3.346A3.323,3.323,0,0,1,173.382,345.753Z",
    transform: "translate(-175.388 -66.174)",
    fill: "#737373"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.321fcadf282b4a249e6ca95b802de05a.svg";
export { ForwardRef as ReactComponent };